export default __webpack_public_path__ + "static/media/logo.82addb7a.png";